import LivePositionDashboard from '../components/statistics/LivePositionDashboard';

function StatisticsLivePositionPage() {
  return <LivePositionDashboard />;
}

export default StatisticsLivePositionPage;
